import {colors} from "patient-ping-remedy/packages/theme";
import styled from '@emotion/styled';

const StyledContainer = styled.span`
  color: ${colors.gray4};
  font-size: 1.3rem;
`;

export { StyledContainer };
